"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Book = void 0;
var _react = _interopRequireDefault(require("react"));
var _Item = require("../Item");
var _LastLocation = require("./partials/LastLocation");
var _MyBooks = require("./partials/MyBooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Book = props => {
  const {
    view = 'default',
    isNew = false,
    url = '',
    banner,
    onItemClick,
    label,
    optionalData,
    isMobileSupported,
    itemTypes,
    title,
    subTitle,
    duration,
    isInMyBooks = false,
    onRemoveBookFromMyBooks,
    currentPageUrl,
    lastLocation
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.Item, {
    type: "book",
    view: view,
    url: url,
    onItemClick: onItemClick,
    banner: banner,
    title: title,
    subTitle: subTitle,
    itemTypes: itemTypes,
    isMobileSupported: isMobileSupported,
    isNew: isNew,
    duration: duration,
    label: label,
    optionalData: optionalData,
    itemBannerChildren: view === 'default' && isInMyBooks && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyBooks.MyBooks, {
      onRemoveBookFromMyBooks: onRemoveBookFromMyBooks,
      optionalData: optionalData,
      view: view
    }),
    itemInfoChildren: view === 'horizontal' && isInMyBooks && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyBooks.MyBooks, {
      onRemoveBookFromMyBooks: onRemoveBookFromMyBooks,
      optionalData: optionalData,
      view: view
    }),
    itemExtraInfoChildren: currentPageUrl && lastLocation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LastLocation.LastLocation, {
      view: view,
      currentPageUrl: currentPageUrl,
      lastLocation: lastLocation,
      optionalData: optionalData
    })
  });
};
exports.Book = Book;